import React from 'react';
import { ParticipantStep } from '../../../../../../types/v3Types';
import { ButtonNames } from '../../../../../../contexts/main/biInterfaces';
import { ChallengeSummary } from '../../../components/ChallengeSummary/ChallengeSummary';
import { OverviewSidebar } from '../../../components/OverviewSidebar';
import { SocialGroupLink } from '../../../../../../components-shared/SocialGroup/SocialGroupLink';
import { classes } from '../SidebarLayoutForParticipant.st.css';
import { SidebarStartButton } from './SidebarStartButton';
import { SectionsList } from './SectionsList';
import { StepsList } from './StepsList';
import { Props } from '../interfaces';
import { useSidebarLayoutBase } from '../contexts/SidebarLayoutBase/SidebarLayoutBaseContext';

export interface SidebarContentProps {
  props: Props;
  currentStep: ParticipantStep | null;
  onStepChosen: (step: ParticipantStep) => void;
  isProgramFinished: boolean;
  getIsStartDisabled: () => boolean;
  setStep: (currentStep: ParticipantStep) => void;
  sendBiButtonClick: (buttonName: ButtonNames, step?: string) => void;
}

export const SidebarContent: React.FC<SidebarContentProps> = ({
  props,
  currentStep,
  onStepChosen,
  isProgramFinished,
  getIsStartDisabled,
  setStep,
  sendBiButtonClick,
}) => {
  const { isSidebarCollapsed } = useSidebarLayoutBase();
  const { challengeData, listParticipantSections } = props;
  const { socialGroupId } = challengeData?.challenge?.settings;

  const isSections = listParticipantSections?.length;

  return (
    <>
      <div className={classes.summary}>
        <ChallengeSummary />
      </div>
      <SidebarStartButton
        props={props}
        isProgramFinished={isProgramFinished}
        getIsStartDisabled={getIsStartDisabled}
        setStep={setStep}
        sendBiButtonClick={sendBiButtonClick}
      />
      <div className={classes.stepsListBox}>
        {!isSidebarCollapsed && (
          <>
            <OverviewSidebar
              onStepChosen={onStepChosen}
              isActive={!currentStep}
            />
            {isSections ? (
              <SectionsList
                currentStep={currentStep}
                onStepChosen={onStepChosen}
              />
            ) : (
              <StepsList
                props={props}
                currentStep={currentStep}
                onStepChosen={onStepChosen}
              />
            )}
          </>
        )}
      </div>
      {socialGroupId ? (
        <div className={classes.groupInSidebar}>
          <SocialGroupLink slug={socialGroupId} iconOnly={isSidebarCollapsed} />
        </div>
      ) : null}
    </>
  );
};
